import Link from 'next/link';
import styles from './SearchLandingError.module.scss';
interface SearchLandingErrorProps {
  query?: string;
}
export default function SearchLandingError(props: SearchLandingErrorProps) {
  const {
    query
  } = props;
  return <div className={styles.shows_landing_error} data-sentry-component="SearchLandingError" data-sentry-source-file="SearchLandingError.tsx">
      {query ? <h2 className={styles.shows_landing_error_header}>
          {`We couldn't find any results for "${query}"`}
        </h2> : <h2 className={styles.shows_landing_error_header}>
          There are no matching results for this search.
        </h2>}


      <p className={styles.shows_landing_error_small}>
        Please try searching again. We suggest using fewer search terms and making sure all of your words are spelled correctly.
      </p>
      <p className={styles.shows_landing_error_small}>
        {`If you’re unable to find a specific show or video, we may not be able to offer it online at this time. `}
        <Link href="https://help.pbs.org/support/solutions/articles/12000036933-i-am-searching-for-a-video-but-i-am-unable-to-find-it-on-the-pbs-website-or-app-" target="_blank" rel="noopener noreferrer" data-sentry-element="Link" data-sentry-source-file="SearchLandingError.tsx">
          Click here
        </Link>
        {` for more information.`}
      </p>
    </div>;
}